<template>
  <div>
    <b-card no-body>
      <!-- Head -->
      <table-header
        search
        search-placeholder="Cari berdasarkan nama"
        search-action="unverified/getProducts"
      />
      <!-- Body -->
      <b-skeleton-table
        v-if="isLoading"
        :rows="5"
        :columns="4"
      />
      <b-table
        v-else
        ref="refUserListTable"
        :items="products.data"
        responsive
        :fields="tableFields"
        primary-key="id"
        show-empty
        empty-text="Tidak ada data yang ditemukan"
        class="position-relative mh-160"
      >

        <!-- Column: Nama -->
        <template #cell(name)="data">
          <b-media
            vertical-align="center"
          >
            <template #aside>
              <b-img
                rounded
                width="50"
                :alt="data.item.name"
                :src="linkStaging(data.item.images.length ? data.item.images[0].image_url : '', 50, 50)"
                @error="(event) => {
                  event.target.src = require('@/assets/images/icons/broken-image.svg')
                }"
              />
            </template>
            <span class="font-weight-bold d-block">
              {{ data.item.name }}
            </span>
          </b-media>
        </template>

        <!-- Column: Kategori -->
        <template #cell(category)="data">
          {{ data.item.category.name }}
        </template>

        <!-- Column: Harga -->
        <template #cell(price)="data">
          {{ toCurrency(data.item.price) }}
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="text-nowrap">
            <b-button
              v-if="canAccess('manage', 'ProductApproval')"
              v-ripple.400="'rgba(40, 199, 111, 0.15)'"
              variant="flat-success"
              @click="showConfirmation({status: true, id: data.item.id})"
            >
              <feather-icon
                icon="CheckIcon"
              /> Approve
            </b-button>
            <b-button
              v-if="canAccess('manage', 'ProductApproval')"
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="flat-danger"
              @click="showConfirmation({status: false, id: data.item.id})"
            >
              <feather-icon
                icon="XIcon"
              /> Reject
            </b-button>
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="flat-primary"
              @click="showDetail(data.item)"
            >
              <feather-icon
                icon="EyeIcon"
              /> Detail
            </b-button>
          </div>
        </template>

      </b-table>
      <!-- Footer -->
      <div class="mx-2 mb-2">
        <pagination
          :data="products.meta"
          action="unverified/getProducts"
        />
      </div>
    </b-card>

    <b-sidebar
      id="sidebar-1"
      v-model="showSidebar"
      title="Detail Produk"
      shadow
      backdrop
      right
      width="520px"
      no-header
    >
      <div class="p-2 border-bottom">
        <h3 class="mb-0">
          Detail Produk
        </h3>
      </div>
      <div class="p-2">
        <b-row>
          <b-col cols="12">
            <b-form-group
              label="Nama Barang"
              label-for="product-name"
            >
              <b-form-input
                id="product-name"
                :value="product.name"
                readonly
              />
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group
              label="Harga"
              label-for="product-price"
            >
              <b-form-input
                id="product-price"
                :value="toCurrency(product.price)"
                readonly
              />
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group
              label="Kondisi"
              label-for="product-condition"
            >
              <b-form-input
                id="product-condition"
                :value="product.condition"
                readonly
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
              label="Deskripsi"
              label-for="product-description"
            >
              <!-- eslint-disable-next-line -->
              <div v-html="product.description" />
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </b-sidebar>

    <b-modal
      v-if="canAccess('manage', 'ProductApproval')"
      id="modal-verified"
      title="Apakah anda yakin"
      @hidden="verifiedData = {}"
    >
      {{ verifiedData.status ? 'Produk akan tersedia secara publik dan dapat dibeli' : 'Produk tidak akan tersedia secara publik dan tidak dapat dibeli' }}
      <template #modal-footer="{ cancel }">
        <b-button
          variant="outline-secondary"
          :disabled="isVerifying"
          @click="cancel()"
        >
          Batalkan
        </b-button>
        <b-button
          :variant="verifiedData.status ? 'success' : 'danger' "
          :disabled="isVerifying"
          @click.prevent="handleVerified"
        >
          <b-spinner
            v-if="isVerifying"
            small
            label="Spinning"
          />
          {{ isVerifying ? 'Memproses' : 'Ya, Setuju' }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import {
  BSkeletonTable,
  BButton,
  BCard,
  BRow,
  BCol,
  BMedia,
  BImg,
  BTable,
  BFormInput,
  BSidebar,
  BFormGroup,
  BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

import TableHeader from '@/layouts/components/custom/TableHeader.vue'
import Pagination from '@/layouts/components/custom/Pagination.vue'

export default {
  components: {
    BSkeletonTable,
    BButton,
    BCard,
    BRow,
    BCol,
    BTable,
    BMedia,
    BImg,
    BFormInput,
    BSidebar,
    BFormGroup,
    BSpinner,
    TableHeader,
    Pagination,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      tableFields: [
        { key: 'name', label: 'Produk' },
        { key: 'category', label: 'Kategori' },
        { key: 'price', label: 'Harga', tdClass: 'text-nowrap' },
        { key: 'actions', label: '', thStyle: { width: '1%' } },
      ],
      verifiedData: {
        id: null,
        status: null,
      },
      product: {},
      searchKeyword: '',
      fixedSearchKeyword: '',
      isVerifying: false,
      showSidebar: false,
    }
  },
  computed: {
    ...mapState('unverified', ['products', 'isLoading']),
    query() {
      return this.$route.query
    },
  },
  async created() {
    await this.getProducts(this.query)
  },
  methods: {
    ...mapActions('unverified', ['getProducts', 'getProduct', 'approveProduct']),
    async showDetail(data) {
      this.product = data
      this.showSidebar = true
    },
    showConfirmation(value) {
      this.$bvModal.show('modal-verified')
      this.verifiedData = value
    },
    async handleVerified() {
      this.isVerifying = true
      await this.approveProduct(this.verifiedData)
      this.isVerifying = false
      this.$bvModal.hide('modal-verified')
    },
  },
}
</script>
